import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavTabModel } from '../../models/nav-tab.model';

@Component({
  selector: 'acc-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss'],
})
export class AccountDetailsComponent implements OnInit {
  navLinks: NavTabModel[];
  activeLinkIndex = -1;

  constructor(private router: Router) {
    this.navLinks = [
      { label: 'Company', link: './company', index: 0 },
      { label: 'Contacts', link: './contacts', index: 1 },
      /*{ label: 'Permissions', link: './permissions', index: 2 },*/
    ];
  }

  ngOnInit() {
    this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find((tab) => this.router.url.includes(tab.link.substring(1))));
    if (this.activeLinkIndex === -1) {
      this.router.navigateByUrl('/accounts/details/company');
    }
  }
}
